// The Incite desktop app's bridge, window.inciteDesktop (desktop/src/preload/index.js;
// feature-specs/desktop_app.md section 5.5). It exists only inside the desktop
// app, on the app origin. Older app versions may lack newer capabilities, so
// check desktopHasCapability before using one, and keep the browser behavior
// when it's missing.
const MIN_API_VERSION = 1;

export const getDesktopBridge = () => {
  if (typeof window === "undefined") return null;
  const bridge = window.inciteDesktop;
  if (!bridge || typeof bridge !== "object") return null;
  if (!Number.isInteger(bridge.apiVersion) || bridge.apiVersion < MIN_API_VERSION) return null;
  return bridge;
};

export const isDesktopApp = () => getDesktopBridge() !== null;

export const desktopHasCapability = (name) => {
  const capabilities = getDesktopBridge()?.capabilities;
  return Array.isArray(capabilities) && capabilities.includes(name);
};

// Analytics fields for events sent from the desktop app (section 7.3). Empty
// in browsers.
export const desktopClientMetadata = () => {
  const app = getDesktopBridge()?.app;
  if (!app) return {};
  return {
    client_surface: "desktop_app",
    desktop_platform: app.platform,
    desktop_version: app.version,
    desktop_channel: app.channel,
  };
};
